export default __webpack_public_path__ + "static/media/choose-3.28826dc6.png";